import React from 'react';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken } from '@vibesites/runtime/react';
import { MarketPage } from './MarketPage';

export function PropertyListing() {
  const pageTitle = useContentToken('propertylisting.page_title');
  return (
    <>
      {/* Hidden EditableToken wrapper so page title is inline-editable */}
      <span aria-hidden="true" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', borderWidth: 0 }}>
        <EditableToken path="propertylisting.page_title" type="text" label="Page Title" defaultValue={contentSchema.tokens['propertylisting.page_title'].defaultValue} as="span">
          {pageTitle}
        </EditableToken>
      </span>
      {/* No initialBounds → map fits to all properties */}
      <MarketPage title={pageTitle || 'Apartments'} />
    </>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FloorplansList',
  displayName: 'Property Listing',
  tokens: {
    'propertylisting.page_title': {
      label: 'Page Title',
      type: 'text',
      defaultValue: 'Apartments',
    },
  },
};

(PropertyListing as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default PropertyListing;
